// @flow

import { type UserInputValidationError, type UserInputValidatorArgs, VALID, onlyWhenSupport } from '@tectonics/prs/validation';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import {
  getCurrentPaymentMethodOptionalFields,
  hasOptionalField,
} from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';
import { shouldDisabledCustomerNameField } from '@tectonics/prs/ui/get-disabled-customer-name-field';
import { validateThaiMobileBankingBankCode } from '@tectonics/prs/thailand/validation/thai-mobile-banking-bank-code';
import { validateThaiCustomerName } from '@tectonics/prs/thailand/validation/thai-customer-name';
import { validateCustomerEmail } from '@tectonics/prs/core/customer/validation/customer-email';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
  incomingPayment,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);
  const optionalFields = incomingPayment.status === 'OP'
    ? getCurrentPaymentMethodOptionalFields(incomingPayment, userInputValues, spec)
    : [];
  // A readonly name comes from the merchant and cannot be fixed by the customer.
  const isReadonlyCustomerName = incomingPayment.status === 'OP'
    && shouldDisabledCustomerNameField(incomingPayment);

  switch (userInputName) {
    case 'selectedBankCode':
      return validateThaiMobileBankingBankCode(
        userInputValues.selectedPaymentMethod,
        userInputValues.selectedEWallet,
        userInputValues.selectedBankCode
      );

    case 'customerName':
      if (hasOptionalField(optionalFields, 'name') || isReadonlyCustomerName) {
        return VALID;
      }
      return onlyWhen('field_thai_customer_name') && validateThaiCustomerName(userInputValue);

    case 'customerEmail':
      if (hasOptionalField(optionalFields, 'email')) {
        return VALID;
      }
      return onlyWhen('field_thai_customer_email') && validateCustomerEmail(userInputValue);

    default:
      return VALID;
  }
}
